import DataSplitSlider from './DataSplitSlider'

export { DataSplitSlider }
export default DataSplitSlider
